import React from 'react';
import { IsObjectEmpty, IsStringEmpty, IsListEmpty } from '../../../../utilities/CommonMethods';
import ModuleOverviewSection from '../../../HomepageSections/ModuleOverviewSection/ModuleOverviewSection';
import ModuleLogo from '../../../../assets/icons/logo-javascript.svg';

import classes from './ModulePerformanceTab.module.css';
import ModuleReportCard from '../../../Cards/ModuleReportCard/ModuleReportCard';
import PerformanceBoardCard from '../../../Cards/PerformanceBoardCard/PerformanceBoardCard';
import LastSessionFeedback from '../../../HomepageSections/LastSessionFeedback/LastSessionFeedback';
import * as actionCreators from '../../../../store/actions/index';
import { connect } from "react-redux";
import ProgressCard from '../../../UI/ProgressCard/ProgressCard';
import LineChart from '../../../UI/Charts/LineChart/LineChart';
import DropDown from '../../../../assets/icons/dropdown-arrow-blue.svg';
import DropDownModal from '../../../UI/DropDownModal/DropDownModal';
import ResourceAPIController from '../../../../webServices/ResourceAPIController';
import ShowLoader from '../../../../hoc/ShowLoader/ShowLoader';

class ModulePerformanceTab extends React.Component {

    state = {
        moduleOverviewData: {
            module: {
                name: 'Javascript',
                logo: ModuleLogo,
                hoursTaught: {
                    value: 45,
                    label: '45%'
                },
                liveSessionProgress: {
                    value: 50,
                    label: '15/35'
                },
                assignmentProgress: {
                    value: 25,
                    label: 1 / 4
                },
                quizProgress: {
                    value: 75,
                    label: '5/6'
                }
            },
            upcomingSessionPlan: []
        },
        moduleReport: {
            classGrades: 0,
            activeStudents: 0,
            totalStudents: 0,
            activeStudentValue: 0,
            rating: 0
        },
        highPerformers: [],
        lowPerformers: [],
        feedbackData: {},
        overallGrade: 0,
        overAllNPS: 0,
        activeStudents: 0,
        totalStudents: 0,
        studentList: [],
        overallAttendance: 0,
        batchCode: this.props.batchCode,
        avgAttendance: true,
        attendance: true,
        grades: false,
        openViewBy: false,
        viewByList: [{ label: 'Weeks' }, { label: 'Months' }],
        itemClicked: 0,
        submissionData: {},
        attendanceData: [],
        chartData: [],
        attendanceOptions: {
            title: 'Average Attendance',
            hTitle: 'Weeks',
            vTitle: 'Percentage (%)'
        },
        gradesData: [],
        gradesOptions: {
            title: 'Average Class Grade',
            hTitle: 'Months',
            vTitle: 'Percentage (%)'
        },
        showLoader: false,
    }

    getModulePerformanceData = () => {
        this.setState({ showLoader: true })
        let responseObj = null;
        ResourceAPIController.getModulePerformanceData(this.props.batchCode, this.props.moduleName)
            .then(response => {
                responseObj = response.result;
                // console.log('get Program Overview Data - response => ', response.result);

                this.setState({
                    showLoader: false,
                    overallGrade: responseObj.overallGrade,
                    activeStudents: responseObj.activeStudents,
                    overallAttendance: responseObj.overallAttendance,
                    totalStudents: responseObj.totalStudents,
                    overallNPS: responseObj.overallNPS,
                    moduleLogo: responseObj.moduleLogo
                });
                this.props.setModuleProgress(responseObj.moduleProgress);
            })
            .catch(err => {
                this.setState({ showLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.HOME_PAGE_PROGRAM_MODULES_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
        this.getLastSessionFeedbackData();
    }

    getLastSessionFeedbackData = () => {
        ResourceAPIController.getLastSessionFeedbackData(this.props.batchCode, this.props.moduleName)
            .then(response => {

                let responseObj = response.result;
                // console.log('Get Last Session Feedback Response => ', responseObj)

                this.setState({
                    showLoader: false,
                    feedbackData: responseObj.feedbackData,
                    submissionData: responseObj.submissionData
                });
            })
            .catch(err => {
                // console.log('Get Last Session Feedback error => ', err)
                this.setState({ showLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
        this.getInstructorOverallReport();
    }

    getInstructorOverallReport = () => {

        ResourceAPIController.getInstructorOverallReport(this.props.batchCode, this.props.moduleName)
            .then(response => {
                // console.log('getInstructorOverallReport Data => ', response.result);
                this.setState({
                    showLoader: false,
                    highPerformers: response.result.highPerformers,
                    lowPerformers: response.result.lowPerformers,
                });

            })
            .catch(err => {
                // console.log('getInstructorOverallReport error => ', err)
                this.setState({ showLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    handleViewBy = (viewBy, value) => {
        this.setState({
            attendanceData: [],
            gradesData: []
        })
        let updatedList = []
        if (value === 'attendance') {
            if (viewBy === 'weeks') {
                !IsListEmpty(this.state.chartData) && this.state.chartData.map((item) => {
                    return updatedList.push([item.weekStartDate, item.attendancePercentage])
                });
                this.setState({
                    attendanceData: [['Weeks', 'Percentage (%)'], ...updatedList],
                    attendanceOptions: { hTitle: 'Weeks' }
                })
            }

            else if (viewBy === 'months') {
                !IsListEmpty(this.state.chartData) && this.state.chartData.map((item) => {
                    return updatedList.push([item.month, item.attendancePercentage])
                });

                this.setState({
                    attendanceData: [['Months', 'Percentage (%)'], ...updatedList],
                    attendanceOptions: { hTitle: 'Months' }
                })
            }
        }

        else if (value === 'classgrades') {
            if (viewBy === 'weeks') {
                !IsListEmpty(this.state.chartData) && this.state.chartData.map((item) => {
                    return updatedList.push([item.weekStartDate, item.avgGrades])
                });
                this.setState({
                    gradesData: [['Weeks', 'Percentage (%)'], ...updatedList],
                    gradesOptions: { hTitle: 'Weeks' }
                })
            }

            else if (viewBy === 'months') {
                !IsListEmpty(this.state.chartData) && this.state.chartData.map((item) => {
                    return updatedList.push([item.month, item.avgGrades])
                });

                this.setState({
                    gradesData: [['Months', 'Percentage (%)'], ...updatedList],
                    gradesOptions: { hTitle: 'Months' }
                })
            }
        }
    }

    getProgramPerformanceAttendanceData = (value) => {
        this.setState({ showLoader: true })
        let responseObj = null;

        let viewBy = this.state.viewByList[value].label.toLowerCase();
        ResourceAPIController.getProgramPerformanceAttendanceData(this.props.batchCode, this.props.moduleName, viewBy)
            .then(response => {
                responseObj = response.result;
                // console.log('get Program Performance Attendance Data - response => ', response.result);

                this.setState({
                    showLoader: false,
                    chartData: responseObj.performanceChartData,
                });
                this.handleViewBy(viewBy, 'attendance')
            })
            .catch(err => {
                this.setState({ showLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.HOME_PAGE_PROGRAM_MODULES_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    getProgramPerformanceClassGradesData = (value) => {
        this.setState({ showLoader: true })
        let responseObj = null;
        let viewBy = this.state.viewByList[value].label.toLowerCase();
        ResourceAPIController.getProgramPerformanceClassGradesData(this.props.batchCode, this.props.moduleName, viewBy)
            .then(response => {
                responseObj = response.result;
                // console.log('get Program Performance Class Grades Data - response => ', response.result);

                this.setState({
                    showLoader: false,
                    chartData: responseObj.performanceChartData,
                });
                this.handleViewBy(viewBy, 'classgrades')
            })
            .catch(err => {
                this.setState({ showLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.HOME_PAGE_PROGRAM_MODULES_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }


    handleChart = (val) => {
        if (val === 'attendance') {
            this.setState({ avgAttendance: true, attendance: true, grades: false, itemClicked: 0 })
            this.getProgramPerformanceAttendanceData(0);
        }
        else if (val === 'grade') {
            this.setState({ avgAttendance: false, attendance: false, grades: true, itemClicked: 0 })
            this.getProgramPerformanceClassGradesData(0);
        }
    }

    onViewModalClick = (pos) => {
        this.setState({ itemClicked: pos })
        this.state.avgAttendance ? this.getProgramPerformanceAttendanceData(pos) : this.getProgramPerformanceClassGradesData(pos);
    }

    componentDidMount() {
        this.getModulePerformanceData();
        this.getProgramPerformanceAttendanceData(0);

    }

    render() {
        return (
            this.state.showLoader
                ? <div className={classes.LoaderContainer}>
                    <ShowLoader isLoading={true} />
                </div> :
                <>
                    {/* ----------- Module Overview Section ----------- */}
                    {/* ----------- Need to work on the redirection of the topics and quizzes to curriculum page ----------- */}
                    <div className={classes.ProgramDetailsPageContainer} onClick={() => this.state.openViewBy && this.setState({ openViewBy: false })}>
                        <h1 className={classes.Heading}>Overview</h1>
                        <div className={classes.ProgressContainer}>
                            <div className={classes.CardContainer}>
                                <ProgressCard
                                    value={this.state.overallAttendance}
                                    label="Avg Attendance" type="percentage"
                                    onClick={() => this.handleChart('attendance')}
                                    clickable={true}
                                    selected={this.state.attendance} />

                                <ProgressCard
                                    value={this.state.overallGrade}
                                    label="Avg Class Grades" type="percentage"
                                    onClick={() => this.handleChart('grade')}
                                    clickable={true}
                                    selected={this.state.grades} />

                                <ProgressCard
                                    value={this.state.overallNPS}
                                    label="NPS" type="number" />

                                <ProgressCard
                                    value={[this.state.activeStudents, this.state.totalStudents]}
                                    label="Active Students" type="fraction" />

                            </div>

                            <div className={classes.GraphHeadingSection}>
                                <h3 className={classes.GraphHeading}>Average {this.state.avgAttendance ? 'Attendance' : 'Class Grade'}</h3>
                                <p className={classes.SortText}
                                    onClick={() => this.setState({ openViewBy: !this.state.openViewBy })}>View By: <span className={classes.SubText}>{this.state.viewByList[this.state.itemClicked].label}</span>
                                    <img src={DropDown} alt="View By" className={[classes.ArrowImg, this.state.openViewBy ? classes.DropDownIconActive : classes.DropDownIcon].join(' ')} onClick={() => this.setState({ openViewBy: !this.state.openViewBy })} width="20" />
                                </p>
                            </div>
                            {this.state.openViewBy && <div className={classes.ModalContainer}>
                                <DropDownModal
                                    itemList={this.state.viewByList}
                                    modalOpen={this.state.openViewBy}
                                    title="View By"
                                    handleClick={this.onViewModalClick}
                                    itemClicked={this.state.itemClicked}
                                />
                            </div>}
                            <LineChart
                                chartData={this.state.avgAttendance
                                    ? this.state.attendanceData
                                    : this.state.gradesData}
                                options={this.state.avgAttendance
                                    ? this.state.attendanceOptions
                                    : this.state.gradesOptions}
                                showLoader={this.state.showLoader}
                            />
                        </div>
                    </div>

                    {/* ----------- Last Session Feedback Section ----------- */}
                    <h4 className={classes.Heading}>Last Session Feedback</h4>
                    {
                        !IsObjectEmpty(this.state.feedbackData)
                            ?
                            <LastSessionFeedback
                                forPerformanceTab={true}
                                data={this.state.submissionData}
                                feedbackData={this.state.feedbackData}
                                batchCode={this.props.batchCode}
                                moduleName={this.props.moduleName}
                                viewAllFeedbacksClick={this.props.viewAllFeedbacksClick}
                            />
                            : <p>Data not available!</p>
                    }

                    {/* ----------- Performance Board Section ----------- */}
                    <h4 className={classes.Heading}>Performance Board</h4>
                    <div className={classes.PerformanceBoardContainer}>
                        <PerformanceBoardCard
                            title={"High Performers"}
                            studentsList={this.state.highPerformers}
                            onViewAllClicked={() => this.props.onViewAllClassGradesClicked(4)} />
                        <PerformanceBoardCard
                            title={"Low Performers"}
                            studentsList={this.state.lowPerformers}
                            onViewAllClicked={() => this.props.onViewAllClassGradesClicked(4)} />
                    </div>

                </>
        );
    }
}

const mapStateToProps = state => {
    return {
        activeProgramBatchCode: state.activeProgramBatchCode,
        activeModuleName: state.activeModuleName,
        activeModuleId: state.activeModuleId,

        showSuccessDialog: state.showSuccessDialog,
        successDialogMessage: state.successDialogMessage,
        successDialogButtonLabel: state.successDialogButtonLabel,
        showFailureDialog: state.showFailureDialog,
        failureDialogMessage: state.failureDialogMessage,
        failureDialogButtonLabel: state.failureDialogButtonLabel,
        somethingWentWrong: state.somethingWentWrong,
        notFound: state.notFound,
        unauthorized: state.unauthorized,
    }
}

const mapDisptachToProps = dispatch => {
    return {
        setTopbarTheme: () => dispatch(actionCreators.setTopbarTheme('Light')),

        setupProgramDetailsTopbar: (showTopbar, showProgramProgress, showModuleProgress) => dispatch(actionCreators.setupProgramDetailsTopbar(showTopbar, showProgramProgress, showModuleProgress)),

        onFailureDialogShow: (msg, btnLabel) => dispatch(actionCreators.onFailureDialogShow(msg, btnLabel)),
        onFailureDialogHide: () => dispatch(actionCreators.onFailureDialogHide()),
        onSuccessDialogShow: (msg, btnLabel) => dispatch(actionCreators.onSuccessDialogShow(msg, btnLabel)),
        onSuccessDialogHide: () => dispatch(actionCreators.onSuccessDialogHide()),

        redirectToUnauthorized: () => dispatch(actionCreators.redirectToUnauthorized()),
        redirectToNotFound: () => dispatch(actionCreators.redirectToNotFound()),
        redirectToServerError: () => dispatch(actionCreators.redirectToServerError()),
        showSessionExpiredDialog: (show) => dispatch(actionCreators.showSessionExpiredDialog(show))

    }
}

export default connect(mapStateToProps, mapDisptachToProps)(ModulePerformanceTab);
